import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { tierPriceInfo, NO_TIER_CATEGORIES } from "@/lib/tierDiscount";

export const NO_TIER_DISCOUNT_CATEGORIES = NO_TIER_CATEGORIES;
export const isTierEligible = (product) => !NO_TIER_CATEGORIES.has((product?.category || "").toLowerCase().trim());

const EMPTY = { tier: "bronze", discount_pct: 0, rows: [], loaded: false, resellerPrices: null };
const TierContext = createContext(EMPTY);

export const TierProvider = ({ children }) => {
  const { user } = useAuth();
  const [tier, setTier] = useState("bronze");
  const [rows, setRows] = useState([]);
  const [resellerPrices, setResellerPrices] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => { api.get("/tier-discounts").then(({ data }) => setRows(data?.rows || [])).catch(() => {}); }, []);
  useEffect(() => {
    setResellerPrices(null);
    if (!user) { setTier("bronze"); setLoaded(true); return; }
    api.get("/me/points").then(({ data }) => {
      setTier(data.tier || "bronze");
      if (data.is_reseller) api.get("/reseller/prices").then((r) => setResellerPrices(r.data?.prices || {})).catch(() => {});
    }).catch(() => setTier("bronze")).finally(() => setLoaded(true));
  }, [user]);

  return <TierContext.Provider value={{ tier, rows, loaded, resellerPrices, isReseller: !!resellerPrices, discount_pct: 0 }}>{children}</TierContext.Provider>;
};

export const useTier = () => useContext(TierContext);

/** Prezzi da mostrare: rivenditore / prezzo fisso tessera / % brand / % default (mai sopra il prezzo normale). */
export const computePrices = (product, tierInfo) => {
  const basePrice = Number(product.price);
  const tier = tierInfo?.tier || "bronze";
  const info = tierPriceInfo(product, basePrice, tier, tierInfo?.rows || [], tierInfo?.resellerPrices);
  const finalPrice = info.price;
  const compareAt = product.compare_at_price && Number(product.compare_at_price) > finalPrice ? Number(product.compare_at_price) : null;
  const listPrice = compareAt || (finalPrice < basePrice ? basePrice : null);
  const hasDiscount = listPrice !== null && listPrice > finalPrice;
  const tierActive = info.source !== null && finalPrice < basePrice;
  const tierLabel = info.source === "reseller" ? "Prezzo rivenditore"
    : info.source === "brand" ? `Prezzo ${tier.toUpperCase()} · -${Math.round(info.pct)}% dal listino`
    : info.source === "default" ? `Prezzo ${tier.toUpperCase()} · -${info.pct}%`
    : `Prezzo ${tier.toUpperCase()}`;
  return { finalPrice, listPrice, hasDiscount, tierEligible: info.source !== null || tier === "bronze", tierPct: info.pct, tierActive, tierLabel, priceSource: info.source };
};
